import React from "react";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
const theme = createTheme({});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AppRoutes />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}

export default App;
